<template>
  <section class="politicas">
    <form-spinner v-if="loading" />
    <ul v-if="politicas">
      <li v-for="(item, i) in politicas" :key="item">
        <header>
          <h5>{{ item.nome }}</h5>
          <div>
            <div>
              <switch-control @change="toggleActivePolitica(i)" v-model:checked="item.ativo" labelOff="Inativo" labelOn="Ativo" labelPos="esq"/>
            </div>
            <span>
              <a href="#" @click.prevent="toggleActive(i)">
                <fa :icon="['far','arrow-up-right-and-arrow-down-left-from-center']" class="icon"/>
              </a>
            </span>
          </div>
        </header>
        <div>
          <table>
            <thead>
              <tr>
                <th colspan="2">Período</th>
                <th colspan="2">Faixa de Valor (R$)</th>
                <th>Qtd. Dias</th>
                <th>Tipos de Bloqueio</th>
                <th>Formas de Pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="fullCell">
                  <input-control cssClass="invis text-center" v-model="item.dtInicial" type="date" :readonly="!item.active"/>
                  <!-- {{ formatDate(item.dtInicial) }} -->
                </td>
                <td class="fullCell">
                  <span :class="['arrowTag', { over: !item.descontoPacote && item.reajuste < item.reajusteFinalMin, under: !item.descontoPacote && item.reajuste > item.reajusteFinalMax }]">
                    <fa :icon="['fas', 'chevrons-right']" />
                  </span>
                  <input-control cssClass="invis text-center" v-model="item.dtFinal" type="date" :readonly="!item.active"/>
                  <!-- {{ formatDate(item.dtFinal) }} -->
                </td>
                <td class="fullCell">
                  <!-- {{ formatMoney(item.valorInicial) }} -->
                  <input-control cssClass="invis text-center" v-model="item.valorInicial" ismoney :readonly="!item.active"/>
                </td>
                <td class="fullCell">
                  <span :class="['arrowTag', { over: !item.descontoPacote && item.reajuste < item.reajusteFinalMin, under: !item.descontoPacote && item.reajuste > item.reajusteFinalMax }]">
                    <fa :icon="['fas', 'chevrons-right']" />
                  </span>
                  <!-- {{ formatMoney(item.valorFinal) }} -->
                    <input-control cssClass="invis text-center" v-model="item.valorFinal" ismoney :readonly="!item.active"/>
                </td>
                <td class="fullCell">
                  <input-control cssClass="invis text-center" v-model="item.quantidadeDiasDebitosVencidos" type="number" :readonly="!item.active"/>
                  <!-- {{ item.quantidadeDiasDebitosVencidos }} -->
                </td>
                <td>
                  <div class="multiple">
                    <span>
                      {{ item.totalTiposBloqueio }}
                    </span>
                    <p v-if="item.totalTiposBloqueio > 0">
                      <!-- Alto Risco, Médio Risco, Bloqueio de Compra, Baixo Risco -->
                       {{ createList(item.tipoBloqueioSelecionados,'descricao') }}
                    </p>
                  </div>
                </td>
                <td>
                  <div class="multiple">
                    <span>
                      {{ item.totalFormasPagamento }}
                    </span>
                    <p v-if="item.totalFormasPagamento > 0">
                      Alto Risco, Médio Risco, Bloqueio de Compra, Baixo Risco
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <template v-if="item.active">
            <div class="sub-content">
              <form-spinner v-if="item.loading" />
              <div class="sub-body">
                <div class="tabs-panel">
                  <nav class="tabs-navs">
                    <div class="tabs-nav active">
                      <a href="#">Tipos de Bloqueio</a>
                    </div>
                    <div class="tabs-nav has-action">
                      <a href="#">
                        Formas de Pagamento
                      </a>
                      <a href="#" class="action">
                        <fa :icon="['far','plus']" />
                      </a>
                    </div>
                  </nav>
                  <div class="tabs-controller">
                    <bloqueios />
                  </div>
                </div>
                <footer>
                  <a href="#" @click.prevent="" class="btn btn-primary">Salvar</a>
                </footer>
              </div>
            </div>
          </template>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import NegociaService from '@/services/negocieja.service.js'
import { formatMoney, formatDate } from '@/services/utils.service.js'
import Bloqueios from '@/components/financeiro/negocieja/bloqueios/SelectBloqueios.vue'

export default {
  components: {
    FormSpinner, Bloqueios
  },
  data () {
    return {
      politicas: null,
      loading: false
    }
  },
  mounted () {
    this.getPoliticas()
  },
  methods: {
    getPoliticas () {
      this.loading = true
      NegociaService.getPoliticas().then(
        response => {
          console.log("politicas", response.data)
          this.politicas = response.data
          this.loading = false
        },
        error => {
          console.error(error)
          this.loading = false
        }
      )
    },
    toggleActive ( i ) {
      this.politicas[i].active = !this.politicas[i].active

      if ( this.politicas[i].active ) {
        this.getDetails(this.politicas[i].idNegocieJaPolitica, i)
      }
    },
    getDetails (idPolitica, i) {
      this.politicas[i].loading = true

      NegociaService.getPolitica(idPolitica).then(
        response => {
          console.log("politica", response.data)
          this.politicas[i].loading = false
          this.politicas[i].details = response.data
        },
        error => {
          console.error(error)
          this.politicas[i].loading = false          
        }
      )
    },
    toggleActivePolitica  ( i ) {
      console.log(i)
    },
    formatMoney ( value ) {
      return formatMoney(value)
    },
    formatDate ( value ) {
      return formatDate(value)
    },
    createList (data, key) {
      return data.map(item => item[key]).join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
  .politicas {
    padding-bottom: $mg_large;

    ul {
      padding: $hmg_mid; margin: 0;

      li {
        list-style: none;
        padding: 0; margin: 0 0 $hmg_mid 0;
        border: $border-component;
        border-radius: $border-radius;
        background-color: $color-secondary;

        header {
          display: flex;
          align-items: center; justify-content: space-between;
          width: 100%; padding: $hmg_small $hmg_mid;
          // border-bottom: $border-component;

          h5, p {
            padding: 0; margin: 0;
          }
          
          >div {
            display: flex;
            align-items: center;
            gap: $mg;
            
            >span {
              display: flex;
              align-items: center;
              gap: $mg_mini;
              font-size: $font-size-large;

              .icon {
                font-size: 16px;
              }
              &:last-child {
                text-align: right;
                margin-left: $hmg_mid;
              }
              
              a {
                color: $color-primary;
              }
            }
          }
        }

        table {
          width: 100%; border-collapse: collapse;
          overflow: hidden;
          table-layout: fixed;

          thead {
            border-top: $border-component;

            tr {
              height: 50px;
              
              th {
                font-size: $font-size-small;
                padding: 0 $hmg_mid;
                text-align: center;

                // &:first-child {
                //   width: 15%;
                //   min-width: 228px;
                //   text-align: left;
                // }
                &:nth-last-child( -n + 2 ) {
                  min-width: 280px; width: 20%; max-width: 360px;
                }
              }
            }
          }
          tbody {
            overflow: hidden;
            border-top: $border-component;

            tr {
              height: 50px;
              overflow: hidden;

              td {
                border: $border-component;
                padding: 0 $hmg_mid;
                position: relative;
                text-align: center;
                z-index: 8;
                
                &:first-child {
                  border-left: none !important;
                  // text-align: left;
                }
                &:last-child {
                  border-right: none !important;
                }

                &.over {
                  background-color: $color-debito;
                }
                &.under {
                  background-color: $color-credito;
                }

                &.fullCell {
                  padding: 0;
                }

                .arrowTag {
                  display: flex; flex-direction: column;
                  justify-content: center; align-items: center;
                  position: absolute; top: 50%; left: 0;
                  transform: translate(-50%, -50%);
                  width: 21px; height: 21px;
                  border-radius: 100%; border: $border-component;
                  font-size: 10px;
                  z-index: 12;
                  color: $color-text; background-color: $color-secondary;

                  &.over {
                    color: $color-primary;
                  }

                  &.under {
                    color: $color-success-2;
                  }
                }

                &.arrowCell {
                  >div {
                    display: flex; align-items: center; justify-content: center;
                    gap: $hmg_mini
                  }
                }

                .multiple {
                  display: flex; align-items: center;
                  gap: $mg_mini; overflow: hidden;
                  
                  span {
                    display: block;
                    width: 24px; height: 24px;
                    text-align: center; line-height: 24px;
                    flex-shrink: 0;
                    border: $border-component;
                    border-radius: 100%;
                  }
                  p {
                    margin: 0; padding: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                }
              }

              &.spinner {
                height: auto;

                td {
                  background-color: $color-secondary;
                  padding: 0 !important;
                }
              }
              &.subHeader {
                height: 40px;
                background-color: $color-bg;

                h4 {
                  margin: 0; padding: 0;
                }
              }

              &:last-child {
                td {
                  border-bottom: none !important;

                  &:last-child {
                    border-right: none !important;
                    border-bottom-right-radius: $border-radius;
                  }
                }
              }
            }
          }
        }

        .sub-content {
          width: 100%;
          border-top: $border-component;

          .sub-body {
            padding: $hmg_mid;

            footer {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-top: $hmg_mid
            }
          }
        }
      }
    }
  }
</style>